import styled from "styled-components";

import { StatPanel } from "./components/StatPanel";
import { Color } from "../Color/Color";
import { Flex } from "../Box/Box";

const ROW_PADDING = "10px";

export const ControlPanelWrapper = styled(Flex)`
  flex-direction: column;
  padding: ${ROW_PADDING};
  border-radius: 4px;
  border: 1px solid ${Color.lightGrayHover};
`;

export const ControlPanelRow = styled(Flex)`
  flex-direction: row;
  justify-content: space-between;
  gap: ${ROW_PADDING};

  :first-of-type {
    padding-bottom: ${ROW_PADDING};
  }

  :not(:first-of-type) {
    border-top: 1px solid ${Color.lightGrayHover};
    padding-top: ${ROW_PADDING};
  }
`;

export const ControlPanelButtons = styled(Flex)`
  flex-direction: row;
  gap: 15px;
`;

export { StatPanel };
